import React from 'react'
import './Content.css'
import { ChildrenProps } from '../../modules/types'

/**
 * The main content for each route should be wrapped in a Content element.
 * This will ensure it is scrollable.
 *
 * Nest inside a <ContentBody> element.
 *
 * @param props
 * @constructor
 */
function Content(props: ChildrenProps) {
  return (
    <div id="content">
      {props.children}
    </div>
  )
}

export default Content
